import React from 'react';
import { CustomNavbar } from '@ui/components/molecules';
import { HeaderLinks } from '@services/data';
import HeaderStyles from './Header.module.scss';

export const Header: React.FC = () => {
  return (
    <div className={HeaderStyles.header}>
      <CustomNavbar links={HeaderLinks} />
    </div>
  );
};
